import Frtabs from 'fr-tabs/dist/frtabs.min';
import {autoOpen} from '../base/utils';

class Tabs {
    constructor($tabs) {
        Frtabs({
            // String - Outer container selector, hook for JS init() method
            selector: '.tabs-wrap',

            // String - List selector to transform into tablist
            tablistSelector: '.tabs-list',

            // String - Containers which hold content, toggled via tabs
            tabpanelSelector: '.tabs-body',

            // String - Class name that will be added to the selector when the component has been initialised
            tabsReadyClass: 'tabs-ready'
        });

        for (let $tabsWrap of $tabs) {
            let $dropdown = $tabsWrap.querySelector('select.js-tabs-dropdown'),
                $tabsLine = $tabsWrap.querySelectorAll('.tabs-tab');

            if ($dropdown) {
                $dropdown.addEventListener('change', e => {
                    let id = e.target.value;

                    if (id) {
                        document.getElementById(id).click();
                    } else {
                        console.warn(`tab with id ${id} not found`);
                    }
                });
            }

            if ($tabsLine) {
                for (let $tab of $tabsLine) {
                    $tab.addEventListener('anchor', () => {
                        $tab.click();
                    });
                }
            }
        }

        window.addEventListener('load', () => {
            autoOpen('.tabs-tab');
        });
    }
}

export default Tabs;
